import { render, staticRenderFns } from "./ManageMaluStudant.vue?vue&type=template&id=df7d649a&scoped=true&"
import script from "./ManageMaluStudant.vue?vue&type=script&lang=js&"
export * from "./ManageMaluStudant.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=df7d649a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7d649a",
  null
  
)

export default component.exports